import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ButtonGenerator from "../ButtonFactory/ButtonGenerator";
import {
  Button,
  Icon,
  Input,
  Modal,
  TextArea,
  Typography,
} from "@anchor/react-components/dist/lib/components";
import UserInfo from "../../context/UserAccessContext";
import { IsLocked } from "../IsLocked/IsLocked";
import ChainedFiveWhys from "./ChainedFiveWhys";

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const QUILL_FORMATS = [
  "header",
  "bold", "italic", "underline",
  "list", "bullet",
  "link",
];
// import { useWebSocket } from "../../context/WebSocketContext/WebSocketContext";

function RciModal({
  handleRciModal,
  rciModal,
  rciData,
  handleRciData,
  increaseQuestions,
  numberOfQuestions,
  handleRciQuestionaireQuestions,
  handleRciQuestionaireAnswers,
  deleteQuestion,
  onSave,
  lockedFields,
  savingRef,
  incidentID, // Add incidentID prop
}) {
  // const {
  //   lockField,
  //   unlockField,
  // } = useWebSocket();
  const lockField = null; // WebSocket disabled
  const unlockField = null; // WebSocket disabled
  const { graphData } = UserInfo();

  // Toggle between classic and chained modes
  const [useChainedMode, setUseChainedMode] = useState(true); // Default to new mode

  const handleFieldLocking = (fieldName) => {
    // lockField(fieldName, graphData.username);
    // WebSocket disabled
  };

  const handleFieldUnlocking = (fieldName) => {
    // unlockField(fieldName, rciData);
    // WebSocket disabled
  };

  const toggleMode = () => {
    const switchMessage = useChainedMode
      ? "Switch to classic 5-Whys format? (Single chain only)"
      : "Switch to chained 5-Whys format? (Multiple chains supported)";
    
    if (window.confirm(switchMessage)) {
      setUseChainedMode(!useChainedMode);
    }
  };

  return (
    <>
      <Modal
        heading={
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", padding: "0 20px" }}>
            <Typography
              variant="h3"
              fontStyle="bold"
              style={{ textAlign: "center", marginTop: "20px" }}
            >
              Root Cause Identification
            </Typography>
            <Button
              label={useChainedMode ? "Switch to Classic" : "Switch to Chained"}
              onClick={toggleMode}
              variant="outlined"
              size="small"
              style={{ marginTop: "20px" }}
            />
          </div>
        }
        onClose={() => {
          handleRciModal();
        }}
        showCloseIcon={true}
        open={rciModal}
      >
        {useChainedMode ? (
          <ChainedFiveWhys
            incidentID={incidentID}
            rciData={rciData}
            handleRciData={handleRciData}
            lockedFields={lockedFields}
            graphData={graphData}
            handleFieldLocking={handleFieldLocking}
            handleFieldUnlocking={handleFieldUnlocking}
            onSave={onSave}
          />
        ) : (
          <>
            {/* Classic 5-Whys Mode */}
            <Typography variant="h3" fontStyle="bold" style={{ fontSize: "18px" }}>
          Description
        </Typography>

        <Typography paragraph={true} style={{ fontSize: "14px" }}>
          <i>
            <strong>Sample: </strong> <br />
            1. The application had an outage as heap ran out of memory <br />
            2. The heap OOM occurred because there was multiple thread in open
            state <br />
            3. Open state because we pushed a change to service and didn’t
            expect the threads to not close at end point <br />
            4. Because we didn’t perform thorough testing in line with
            production load <br />
            5. Because we believed Pre-production was near to production and
            testing gave us sufficient result to push the change to production.
          </i>
        </Typography>
        <ReactQuill
          theme="snow"
          value={rciData.description}
          onChange={(html) =>
            handleRciData({ target: { name: "description", value: html } })
          }
          onFocus={() => handleFieldLocking("rci_description")}
          onBlur={() => handleFieldUnlocking("rci_description")}
          modules={QUILL_MODULES}
          formats={QUILL_FORMATS}
          placeholder="Please provide a description of the root cause identification, perform a full 5-why or pareto or fish-bone analysis"
          style={{ background: "#fff" }}
        />
        <IsLocked
          field="rci_description"
          lockedFields={lockedFields}
          graphData={graphData}
        />

        <Typography variant="h3" fontStyle="bold" style={{ fontSize: "18px" }}>
          5 Whys
          <ButtonGenerator
            appearance="default"
            id="primary"
            justifyItems="center"
            label="+ Add Question"
            name="primary"
            onClick={increaseQuestions}
            title="Submit"
            variant="filledAlt"
            style={{ marginLeft: "10px" }}
            disabled={numberOfQuestions === 5}
          />
        </Typography>

        <div className="questionsWrapper">
          <div className="questions">
            {Array.from({ length: numberOfQuestions }, (_, index) => (
              <div
                style={{
                  // display: "flex",
                  marginBottom: "10px",
                  justifyContent: "space-between",
                }}
                key={index}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                  }}
                >
                  <Input
                    onChange={(event) =>{
                      handleRciQuestionaireQuestions(event, index)
                      handleFieldLocking('rci_questions')
                    }

                    }

                    onFocus={() => handleFieldLocking('rci_questions')}
                    onBlur={() => handleFieldUnlocking('rci_questions')}
                    disabled={
                      lockedFields.find(
                        (field) =>
                          field.fieldName === "rci_questions" &&
                          field.lockedBy !== graphData.username
                      )
                    }
                    value={
                      rciData &&
                      rciData.questions[index] &&
                      rciData.questions[index].question
                    }
                    label={`Question ${index + 1}`}
                    style={{ marginRight: "10px" }}
                  />
                  <div
                    className="delete-iconContainer"
                    onClick={() => deleteQuestion(index)}
                  >
                    <Icon style={{ color: "red" }} name="times-circle" />
                  </div>
                </div>

                <TextArea
                  fit="medium"
                  id="text-area"
                  name="description"
                  onChange={(event) => {
                    handleRciQuestionaireAnswers(event, index)
                    handleFieldLocking('rci_questions')
                  }
                  }
                  onFocus={() => handleFieldLocking('rci_questions')}
                  onBlur={() => handleFieldUnlocking('rci_questions')}
                  spellCheck={true}
                  lang="en"
                  disabled={
                    lockedFields.find(
                      (field) =>
                        field.fieldName === "rci_questions" &&
                        field.lockedBy !== graphData.username
                    )
                  }
                  value={
                    rciData &&
                    rciData.questions[index] &&
                    rciData.questions[index].answer
                  }
                  label={`Answer ${index + 1}`}
                  rows={5}
                />
              </div>
            ))}
          </div>
        </div>
        </>
        )}

      </Modal>
    </>
  );
}

export default RciModal;
